<template>
  <div>
    <BaseTopLine>
      <div class="d-flex gap-10 align-items-center"></div>
    </BaseTopLine>
    <!-- новая разметка -->
    <div
      ref="transportQuickFilterBar"
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px]"
    >
      <div class="tw-flex tw-items-end tw-gap-[20px] tw-text-white">
        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">RIN</label>
          <BaseInputNew
            inputClass="tw-app-input-dark"
            placeholder=""
            :inputStyle="{ width: '100%' }"
            :disabled="false"
            @input="handleQuickRinInput"
            :additionalParams="{ type: 'input' }"
            inputName="vehicles__id"
            :value="quickFilterRin"
            nameSign=""
          />
        </div>
        <div class="tw-app-input-container multiselect-type-1">
          <label class="tw-app-input-container-label">Город</label>
          <BaseSelect
            v-model="selectsFilter.city"
            track-by="cities__id"
            label="cities__name"
            @input="setFilterCity"
            style="width: 100%"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            :options="quickFilterCitiesOptions"
            :custom-label="quickFilterCityLabel"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template>
            <template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>
        <div class="tw-app-input-container multiselect-type-1">
          <label class="tw-app-input-container-label">Площадка</label>
          <BaseSelect
            v-model="selectsFilter.place"
            track-by="vehicle_places__id"
            label="vehicle_places__name"
            @input="setFilterPlace"
            style="width: 100%"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            :options="quickFilterPlacesOptions"
            :custom-label="quickFilterPlaceLabel"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template>
            <template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>
        <div class="tw-app-input-container multiselect-type-1">
          <label class="tw-app-input-container-label">Марка / модель</label>
          <BaseSelect
            v-model="selectsFilter.markModel"
            @input="setFilterMarkModel"
            style="width: 100%"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            :options="quickFilterMarkModelOptions"
            :custom-label="quickFilterMarkModelLabel"
            track-by="vehicles__name"
            label="vehicles__name"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template>
            <template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>
        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label"
            >Гос. номер (или часть)</label
          >
          <BaseInputNew
            inputClass="tw-app-input-dark"
            placeholder=""
            :inputStyle="{ width: '100%' }"
            :disabled="false"
            @input="handleQuickGosNumberInput"
            :additionalParams="{ type: 'like' }"
            inputName="vehicles__gosnumber"
            :value="quickFilterGosNumber"
            nameSign=""
          />
        </div>
        <div class="tw-flex tw-flex-row">
          <button
            type="button"
            class="tw-app-btn-primary"
            @click="clickLoadData(1)"
          >
            Найти
          </button>
          <button type="button" class="tw-app-btn-light" @click="resetFilter">
            Сбросить
          </button>
        </div>
      </div>
    </div>
    <!-- новая разметка -->
    <!-- старая разметка -->
    <!-- <div ref="transportQuickFilterBar" class="transport-quick-filter-bar">
      <div class="transport-quick-filter-bar__inner px-10 d-flex align-items-end flex-wrap">
        <div class="transport-quick-filter-bar__group">
          <label class="transport-quick-filter-bar__label">RIN</label>
          <BaseInputNew placeholder="" :inputStyle="{ width: '100%' }" :disabled="false" @input="handleQuickRinInput"
            :additionalParams="{ type: 'input' }" inputName="vehicles__id" :value="quickFilterRin" nameSign="" />
        </div>
        <span class="transport-quick-filter-bar__vrule" aria-hidden="true" />
        <div class="transport-quick-filter-bar__group transport-quick-filter-bar__group--grow">
          <label class="transport-quick-filter-bar__label">Город</label>
          <BaseSelect v-model="selectsFilter.city" track-by="cities__id" label="cities__name" @input="setFilterCity"
            style="width: 100%" placeholder="" selectLabel="" deselectLabel="" :options="quickFilterCitiesOptions"
            :custom-label="quickFilterCityLabel">
            <template slot="noOptions">{{ dataLang['select_empty'] }}</template>
            <template slot="noResult">{{ dataLang['select_search_empty'] }}</template>
            <template slot="selectedLabel">{{ dataLang['select_selected'] }}</template>
            <template slot="deselectLabel">{{ dataLang['select_unselect'] }}</template>
          </BaseSelect>
        </div>
        <span class="transport-quick-filter-bar__vrule" aria-hidden="true" />
        <div class="transport-quick-filter-bar__group transport-quick-filter-bar__group--grow">
          <label class="transport-quick-filter-bar__label">Площадка</label>
          <BaseSelect v-model="selectsFilter.place" track-by="vehicle_places__id" label="vehicle_places__name"
            @input="setFilterPlace" style="width: 100%" placeholder="" selectLabel="" deselectLabel="" :options="quickFilterPlacesOptions"
            :custom-label="quickFilterPlaceLabel">
            <template slot="noOptions">{{ dataLang['select_empty'] }}</template>
            <template slot="noResult">{{ dataLang['select_search_empty'] }}</template>
            <template slot="selectedLabel">{{ dataLang['select_selected'] }}</template>
            <template slot="deselectLabel">{{ dataLang['select_unselect'] }}</template>
          </BaseSelect>
        </div>
        <span class="transport-quick-filter-bar__vrule" aria-hidden="true" />
        <div class="transport-quick-filter-bar__group transport-quick-filter-bar__group--grow">
          <label class="transport-quick-filter-bar__label">Марка / модель</label>
          <BaseSelect
            v-model="selectsFilter.markModel"
            @input="setFilterMarkModel"
            style="width: 100%"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            :options="quickFilterMarkModelOptions"
            :custom-label="quickFilterMarkModelLabel"
            track-by="vehicles__name"
            label="vehicles__name">
            <template slot="noOptions">{{ dataLang['select_empty'] }}</template>
            <template slot="noResult">{{ dataLang['select_search_empty'] }}</template>
            <template slot="selectedLabel">{{ dataLang['select_selected'] }}</template>
            <template slot="deselectLabel">{{ dataLang['select_unselect'] }}</template>
          </BaseSelect>
        </div>
        <span class="transport-quick-filter-bar__vrule" aria-hidden="true" />
        <div class="transport-quick-filter-bar__group transport-quick-filter-bar__group--grow">
          <label class="transport-quick-filter-bar__label">Гос. номер (или часть)</label>
          <BaseInputNew placeholder="" :inputStyle="{ width: '100%' }" :disabled="false" @input="handleQuickGosNumberInput"
            :additionalParams="{ type: 'like' }" inputName="vehicles__gosnumber" :value="quickFilterGosNumber" nameSign="" />
        </div>
        <span class="transport-quick-filter-bar__vrule" aria-hidden="true" />
        <div class="transport-quick-filter-bar__actions d-flex flex-column align-items-stretch gap-5 ms-auto">
          <button type="button" class="transport-quick-filter-bar__btn-find" @click="clickLoadData(1)">
            Найти
          </button>
          <button type="button" class="transport-quick-filter-bar__btn-reset" @click="resetFilter">
            Сбросить
          </button>
        </div>
      </div>
    </div> -->
    <!-- старая разметка -->
    <!-- старые кнопки -->
    <div class="tw-px-[26px]">
      <!-- новые кнопки -->
      <div class="tw-my-[15px] tw-flex tw-items-center tw-gap-[10px]">
        <button class="tw-app-btn-primary" @click="checkClient">
          <img
            :src="require(`@/assets/icons/addwhite.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          {{ dataLang["registry_ads_text1"] }}
        </button>
        <button
          class="tw-app-btn-primary-outline"
          @click="deleteActionAndModal"
        >
          <img
            :src="require(`@/assets/icons/minus-dark.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          {{ dataLang["registry_ads_text2"] }}
        </button>
        <button class="tw-app-btn-primary-outline" @click="toArhive">
          <img
            :src="require(`@/assets/icons/arhive-dark.svg`)"
            width="16"
            height="16"
            class="tw-my-[-5px]"
          />
          В архив
        </button>
        <button class="tw-app-btn-primary-outline" @click="duplicateRows">
          <img
            :src="require(`@/assets/icons/copy-dark.svg`)"
            width="16"
            height="16"
            class="tw-my-[-5px]"
          />
          Дублировать
        </button>
        <button
          class="tw-app-btn-primary-outline"
          @click="toExcelTransportVehiclesData({ type: 'car', where: filter })"
        >
          <img
            :src="require(`@/assets/icons/excel-dark.svg`)"
            width="16"
            height="16"
            class="tw-my-[-5px]"
          />
          в Excel
        </button>
      </div>
      <!-- новые кнопки -->
      <!-- старые кнопки -->
      <!-- <div class="d-flex justify-content-between align-items-center pt-15 pb-10">
        <div class="d-flex gap-10 align-items-center">
          <div class="base-button base-button--action" @click="checkClient">
            <img :src="require(`@/assets/icons/add.svg`)" width="13.5" height="13.5" />
            <span class="fsc-14">{{ dataLang['registry_ads_text1'] }}</span>
          </div>
          <div class="base-button base-button--action position-relative" @click="deleteActionAndModal">
            <img :src="require(`@/assets/icons/adddel.svg`)" width="13.5" height="13.5" />
            <span class="fsc-14">{{ dataLang['registry_ads_text2'] }}</span>
            <img :src="require(`@/assets/icons/lockdark.svg`)" width="10" height="10"
              style="position: absolute; top: 1px; right: 1px" />
          </div>
          <div class="base-button base-button--action position-relative"
            @click="activeSelectRowsMultiple.length ? $modal.show('acceptToArchive') : ''">
            <img :src="require(`@/assets/icons/to-folder.svg`)" width="16" height="16" />
            <span class="fsc-14"> В архив</span>
            <img :src="require(`@/assets/icons/lockdark.svg`)" width="10" height="10"
              style="position: absolute; top: 1px; right: 1px" />
          </div>
          <div class="base-button base-button--action" @click="duplicateRows">
            <img :src="require(`@/assets/icons/document-copy.svg`)" width="16" height="16" />
            <span class="fsc-14"> Дублировать</span>
          </div>
          <div class="base-button base-button--action" @click="
            toExcelTransportVehiclesData({ type: 'car', where: filter })
            ">
            <img :src="require(`@/assets/icons/to-exel.svg`)" width="16" height="16" />
            <span class="fsc-14">в Excel</span>
          </div>
        </div>
        <div></div>
      </div> -->
      <!-- старые кнопки -->
      <div class="d-flex align-items-center flex-wrap" style="gap: 1px">
        <div
          v-if="quickOrderProductsById[3]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(3)"
        >
          {{ getQuickOrderButtonTitle(3) }}
        </div>
        <div
          v-if="quickOrderProductsById[1]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(1)"
        >
          {{ getQuickOrderButtonTitle(1) }}
        </div>
        <div
          v-if="quickOrderProductsById[2]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(2)"
        >
          {{ getQuickOrderButtonTitle(2) }}
        </div>
        <div
          v-if="quickOrderProductsById[4]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(4)"
        >
          {{ getQuickOrderButtonTitle(4) }}
        </div>
        <div
          v-if="quickOrderProductsById[5]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(5)"
        >
          {{ getQuickOrderButtonTitle(5) }}
        </div>
        <div
          v-if="evacuationProductId"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(evacuationProductId)"
        >
          {{ getQuickOrderButtonTitle(evacuationProductId) }}
        </div>
        <div
          v-if="quickOrderProductsById[11]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(11)"
        >
          {{ getQuickOrderButtonTitle(11) }}
        </div>
        <div
          v-if="quickOrderProductsById[12]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(12)"
        >
          {{ getQuickOrderButtonTitle(12) }}
        </div>
        <div
          v-if="quickOrderProductsById[13]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(13)"
        >
          {{ getQuickOrderButtonTitle(13) }}
        </div>
        <div
          v-if="quickOrderProductsById[14]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(14)"
        >
          {{ getQuickOrderButtonTitle(14) }}
        </div>
        <div
          v-if="quickOrderProductsById[15]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(15)"
        >
          {{ getQuickOrderButtonTitle(15) }}
        </div>
        <div
          v-if="quickOrderProductsById[22]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(22)"
        >
          {{ getQuickOrderButtonTitle(22) }}
        </div>
        <div
          v-if="quickOrderProductsById[23]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(23)"
        >
          {{ getQuickOrderButtonTitle(23) }}
        </div>
        <div
          v-if="quickOrderProductsById[6]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(6)"
        >
          {{ getQuickOrderButtonTitle(6) }}
        </div>
        <div
          v-if="quickOrderProductsById[25]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(25)"
        >
          {{ getQuickOrderButtonTitle(25) }}
        </div>
        <div
          v-if="quickOrderProductsById[26]"
          style="
            padding: 10px 8px;
            font-size: 12px;
            line-height: 14px;
            flex-grow: 1;
            text-align: center;
          "
          class="line-hover cursor-pointer"
          @click="openQuickOrderModalById(26)"
        >
          {{ getQuickOrderButtonTitle(26) }}
        </div>
      </div>

      <!-- новая строка -->
      <div class="tw-flex tw-justify-between tw-py-[15px]">
        <div class="tw-flex">
          <button @click="clickLoadData(1)" class="tw-app-btn-primary-outline">
            {{ dataLang["register_btn_filter_on"] }}
          </button>
          <button
            @click="resetFilter"
            class="tw-app-btn-light !tw-text-[#0056AF]"
          >
            {{ dataLang["register_btn_filter_off"] }}
          </button>
        </div>
        <TwBasePagination
          :page-count="numPages"
          :pagination-params="{
            ...paginationStateParams,
            limit: limitPaginationValue,
          }"
          @updateLimitValue="updateLimitValue"
          :page-range="10"
          :margin-pages="2"
          :break-view-class="''"
          :click-handler="clickLoadData"
          :prev-text="''"
          :next-text="''"
        >
        </TwBasePagination>
      </div>
      <!-- старая строка -->
      <!-- <div class="d-flex gap-15 align-items-center justify-content-between pb-10">
        <div class="d-flex gap-15 align-items-center justify-content-between">
          <div class="btn btn-sm btn-thrity text-white fsc-14" @click="clickLoadData(1)">
            {{ dataLang['register_btn_filter_on'] }}
          </div>
          <div class="text-decoration-underline fsc-14 text-dark" style="cursor: pointer" @click="resetFilter">
            {{ dataLang['register_btn_filter_off'] }}
          </div>
        </div>
        <BasePagination :page-count="numPages"
          :pagination-params="{ ...paginationStateParams, limit: limitPaginationValue }"
          @updateLimitValue="updateLimitValue" :page-range="10" :margin-pages="2" :break-view-class="''"
          :click-handler="clickLoadData" :prev-text="''" :next-text="''" :container-class="'custom-pagination'"
          :page-class="'custom-pagination__item'" :pageLinkClass="'custom-pagination__item-link'">
        </BasePagination>
      </div> -->
      <!-- старая строка -->
      <div class="position-relative">
        <div
          class="d-flex fsc-24 justify-content-center align-items-center text-center position-absolute top-0 left-0 bg-white"
          style="height: 500px; width: 100%; flex-grow: 1"
          v-if="transportVehiclesLoadStatus == 'request'"
        >
          Подождите, загружаю реестр объектов
        </div>
        <div class="transport-table fixed-header rest-style-table">
          <ve-table
            style="width: 100%"
            :rowStyleOption="rowStyleOption"
            :cellSelectionOption="cellSelectionOption"
            :columns="columns"
            :table-data="transportVehiclesData"
            :border-x="true"
            :border-y="true"
            :checkbox-option="checkboxOption"
            row-key-field-name="rowKey"
            :sort-option="sortOption"
            v-if="transportVehiclesLoadStatus == 'success' && loadAllSelect"
            :cell-style-option="cellStyleOption"
            :eventCustomOption="eventCustomOption"
            ref="mainTable"
          />
        </div>
      </div>
    </div>
    <BaseModal
      name="vehicleSettingModal"
      width="1280"
      :clickToClose="false"
      :shiftY="0.5"
      @before-open="beforeOpen"
      @before-close="beforeClose"
      :adaptive="true"
      :minHeight="800"
      classes="bg-white shadow-none"
    >
      <div
        class="position-relative d-flex flex-column h-100"
        ref="vehicleModalWrapper"
      >
        <div
          v-if="loadingModal"
          class="position-absolute wp-100 h-100 d-flex justify-content-center align-items-center bg-white"
          style="top: 0; left: 0; z-index: 500"
        >
          <svg class="spinner" viewBox="0 0 50 50">
            <circle
              class="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
            ></circle>
          </svg>
        </div>
        <div
          class="d-flex justify-content-between px-30 py-10 align-items-center"
        >
          <div class="d-flex text-dark">
            <span
              class="fsc-12 fw-medium lh-1"
              v-if="modeOpenModal == 'create'"
            >
              Добавление объекта в категорию
              <span class="fsc-12 fw-bolder">"Легковой"</span>
            </span>
            <div
              class="d-flex gap-30 align-items-center fsc-12"
              v-if="lineTitle && modeOpenModal == 'edit'"
            >
              <div class="d-flex align-items-center gap-5">
                <span class="fw-medium lh-1">{{ lineTitle.name }}</span
                ><span class="fw-bolder">{{ lineTitle.gosnumber }}</span>
              </div>

              <div class="d-flex align-items-center">
                <span class="fw-medium">RIN&nbsp;</span
                ><span class="fw-bolder lh-1"
                  >{{ lineTitle.idObject }}&nbsp;</span
                >
                <span class="fw-medium text-muted" v-if="lineTitle.created_at"
                  >({{
                    $time(lineTitle.created_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(`${this.userSetting.company__tempalte_date}`)
                  }})</span
                >
              </div>
              <div class="d-flex align-items-center gap-5">
                <span class="fw-medium">{{
                  dataLang["vehile_modal_title_odometr"]
                }}</span>
                <span class="fw-bolder lh-1">{{ lineTitle.odomert }}</span>
                <span
                  class="fw-medium text-muted"
                  v-if="lineTitle.odometrNextDate"
                  >({{
                    $time(lineTitle.odometrNextDate)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(`${this.userSetting.company__tempalte_date}`)
                  }})</span
                >
              </div>
              <div class="d-flex align-items-center gap-5">
                <span class="fw-medium">{{
                  dataLang["interval_events_for_object_text52"]
                }}</span>
                <span class="fw-bolder lh-1">{{ lineTitle.motohour }}</span>
                <span
                  class="fw-medium text-muted"
                  v-if="lineTitle.motohourLastUpdated"
                  >({{
                    $time(lineTitle.motohourLastUpdated)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(`${this.userSetting.company__tempalte_date}`)
                  }})</span
                >
              </div>
              <div class="d-flex align-items-center gap-5">
                <span class="fw-medium">{{
                  dataLang["vehile_modal_title_id_owner"]
                }}</span>
                <span class="fw-bolder lh-1">{{ lineTitle.idOwner }}</span>
              </div>
              <div class="d-flex align-items-center gap-5">
                <span class="fw-medium">{{
                  dataLang["vehile_modal_title_id_place"]
                }}</span>
                <span class="fw-bolder lh-1">{{ lineTitle.idPlace }}</span>
              </div>
              <div class="d-flex align-items-center gap-5">
                <span class="fw-medium">{{
                  dataLang["vehile_modal_title_rayting"]
                }}</span>
                <span class="fw-bolder lh-1">{{ lineTitle.rayting }}</span>
              </div>
              <div class="d-flex align-items-center gap-5 ms-130">
                <span class="fw-medium">{{
                  dataLang["vehile_modal_title_status"]
                }}</span>
                <span class="fw-bolder lh-1" :class="[lineTitle.statusClass]">{{
                  lineTitle.status
                }}</span>
              </div>
            </div>
          </div>
          <button
            type="button"
            class="btn-close p-0"
            @click="$modal.hide('vehicleSettingModal')"
          ></button>
        </div>
        <div class="d-flex flex-column flex-grow-1" v-if="modalOpened">
          <vue-tabs
            v-model="activateTab"
            @tab-change="handleTabChange"
            class="vue-tabs-type-1 flex-grow-1"
          >
            <v-tab
              :title="dataLang['vehicles_page__modal__tab_object__name']"
              data-name="vehicleTab"
            >
              <div class="px-30 pt-10 pb-5">
                <VehicleTab
                  ref="vehicleTab"
                  :modeOpenModal="modeOpenModal"
                  @reloadData="clickLoadData(1)"
                  @loadingModal="loadingModalHandler"
                  @changeErrorInTab="changeErrorInTab"
                  :currentOpenedId="currentOpenedId"
                  v-if="listTabs.vehicleTab"
                ></VehicleTab>
              </div>
            </v-tab>
            <v-tab
              :title="dataLang['vehicles_page__modal__tab_service__name']"
              data-name="servicesTab"
              v-if="modeOpenModal == 'edit'"
            >
              <div class="px-30 pt-10 pb-5">
                <ServicesTab
                  ref="servicesTab"
                  :modeOpenModal="modeOpenModal"
                  v-if="listTabs.servicesTab"
                  @loadingModal="loadingModalHandler"
                  :currentOpenedId="currentOpenedId"
                ></ServicesTab>
              </div>
            </v-tab>
            <v-tab
              title="Замечания в актах"
              data-name="notesTab"
              v-if="modeOpenModal == 'edit'"
            >
              <div class="px-30 pt-10 pb-5">
                <NotesTab
                  ref="notesTab"
                  :modeOpenModal="modeOpenModal"
                  v-if="listTabs.notesTab"
                  @loadingModal="loadingModalHandler"
                  :currentOpenedId="currentOpenedId"
                ></NotesTab>
              </div>
            </v-tab>
            <v-tab
              :title="dataLang['vehicles_page__modal__tab_security__name']"
              data-name="securityTab"
              v-if="modeOpenModal == 'edit'"
            >
              <div class="px-30 pt-10 pb-5">
                <SecurityTab
                  ref="securityTab"
                  :modeOpenModal="modeOpenModal"
                  v-if="listTabs.securityTab"
                  @loadingModal="loadingModalHandler"
                  :currentOpenedId="currentOpenedId"
                ></SecurityTab>
              </div>
            </v-tab>
            <v-tab
              :title="dataLang['vehicles_page__modal__tab_tires__name']"
              data-name="tiresTab"
              v-if="modeOpenModal == 'edit'"
            >
              <TiresTab
                ref="tiresTab"
                :modeOpenModal="modeOpenModal"
                v-if="listTabs.tiresTab"
                @loadingModal="loadingModalHandler"
                :currentOpenedId="currentOpenedId"
              ></TiresTab>
            </v-tab>
            <v-tab
              :title="dataLang['vehicles_page__modal__tab_files__name']"
              data-name="filesTab"
              v-if="modeOpenModal == 'edit'"
            >
              <FilesTab
                ref="filesTab"
                :modeOpenModal="modeOpenModal"
                v-if="listTabs.filesTab"
                @loadingModal="loadingModalHandler"
                @forceReload="forceReload"
                :currentOpenedId="currentOpenedId"
              >
              </FilesTab>
            </v-tab>

            <v-tab
              :title="dataLang['vehicles_page__modal__tab_rayting__name']"
              data-name="raytingTab"
              v-if="modeOpenModal == 'edit'"
            >
              <RaytingTab
                ref="raytingTab"
                :modeOpenModal="modeOpenModal"
                v-if="listTabs.raytingTab"
                @loadingModal="loadingModalHandler"
                :currentOpenedId="currentOpenedId"
              ></RaytingTab>
            </v-tab>

            <v-tab
              :title="dataLang['vehicles_page__modal__tab_rent__name']"
              data-name="settingTab"
              v-if="modeOpenModal == 'edit'"
            >
              <div class="px-30 pt-10 pb-5">
                <SettingTab
                  ref="settingTab"
                  :modeOpenModal="modeOpenModal"
                  v-if="listTabs.settingTab"
                  @loadingModal="loadingModalHandler"
                  :currentOpenedId="currentOpenedId"
                ></SettingTab>
              </div>
            </v-tab>

            <v-tab
              title="Интервалы"
              data-name="intervalEventsTab"
              v-if="modeOpenModal == 'edit'"
            >
              <div class="px-30 pt-10 pb-5">
                <IntervalEventsTab
                  ref="intervalEventsTab"
                  :modeOpenModal="modeOpenModal"
                  v-if="listTabs.intervalEventsTab"
                  @loadingModal="loadingModalHandler"
                  :currentOpenedId="currentOpenedId"
                ></IntervalEventsTab>
              </div>
            </v-tab>

            <v-tab
              :title="dataLang['vehicles_page__modal__tab_comments__name']"
              data-name="commentsTab"
              v-if="modeOpenModal == 'edit'"
            >
              <div class="px-30 py-10">
                <CommentsTab
                  ref="commentsTab"
                  :modeOpenModal="modeOpenModal"
                  v-if="listTabs.commentsTab"
                  @loadingModal="loadingModalHandler"
                  :currentOpenedId="currentOpenedId"
                ></CommentsTab>
              </div>
            </v-tab>
          </vue-tabs>
          <div
            class="line-state"
            v-if="lineHealthVehicle && modeOpenModal == 'edit'"
          >
            <div
              v-for="(item, index) in lineHealthVehicle"
              :key="index"
              class="line-state__badge"
              :class="[item.class]"
              @mouseenter="onHealthBadgeEnter($event, item, index)"
              @mouseleave="onHealthBadgeLeave"
            >
              {{ dataLang[item.name] }}
            </div>
          </div>

          <!-- Health tooltip bubble -->
          <div
            v-show="healthTooltip.visible"
            class="health-tooltip"
            :style="{
              left: healthTooltip.left + 'px',
              top: healthTooltip.top + 'px',
              width: healthTooltip.width + 'px',
              '--arrow-left': healthTooltip.arrowLeft + 'px',
            }"
            @mouseenter="onTooltipEnter"
            @mouseleave="onTooltipLeave"
          >
            <div
              class="health-tooltip__content"
              v-html="healthTooltip.text"
            ></div>
          </div>
          <div class="d-flex justify-content-between gap-30 mt-5 pb-5">
            <div
              v-if="dataForPageOnModal.vehicles__id"
              class="d-flex align-items-center gap-10 ps-30"
            >
              <button
                class="tw-app-btn-primary tw-app-btn-primary-lg !tw-bg-forLine !tw-text-[#111E31] !tw-gap-[10px]"
                @click="
                  () => {
                    activeModalForPin = 'block';
                    $modal.show('acceptWithPin');
                  }
                "
              >
                <img
                  :src="require(`@/assets/icons/lock-close-dark.svg`)"
                  height="16"
                />
                Заблокировать
              </button>
              <button
                class="tw-app-btn-primary tw-app-btn-primary-lg !tw-bg-forLine !tw-text-[#111E31] !tw-gap-[10px]"
                @click="
                  () => {
                    activeModalForPin = 'unblock';
                    $modal.show('acceptWithPin');
                  }
                "
              >
                <img
                  :src="require(`@/assets/icons/lock-open-dark.svg`)"
                  height="16"
                />
                Разблокировать
              </button>
            </div>
            <div
              v-if="dataForPageOnModal.vehicles__id"
              class="d-flex gap-10 fsc-11 fw-medium align-items-center"
            >
              <div class="text-muted">Сейчас объект:</div>
              <div
                class="tw-flex tw-gap-[5px] tw-bg-[#E8FEEE] tw-text-[#23B14D] tw-rounded-[30px] tw-py-[6px] tw-px-[10px] tw-capitalize"
                :class="{
                  'tw-bg-[#E8FEEE] tw-text-[#23B14D]':
                    dataForPageOnModal?.vehicles__engine_status_by_command ==
                    'разблокирован',
                  'tw-bg-[#ff3a2054] tw-text-[#FF3A20]':
                    dataForPageOnModal?.vehicles__engine_status_by_command !=
                    'разблокирован',
                }"
              >
                <img
                  v-if="
                    dataForPageOnModal?.vehicles__engine_status_by_command ==
                    'разблокирован'
                  "
                  :src="require(`@/assets/icons/lock-open-green.svg`)"
                  height="16"
                />
                <img
                  v-if="
                    dataForPageOnModal?.vehicles__engine_status_by_command !=
                    'разблокирован'
                  "
                  :src="require(`@/assets/icons/lock-close-red.svg`)"
                  height="16"
                />
                {{ dataForPageOnModal?.vehicles__engine_status_by_command }}
              </div>
              <!-- <div
                :style="{ color: dataForPageOnModal?.vehicles__engine_status_by_command == 'разблокирован' ? '#23B14D' : '#FF3A20' }">
                {{ dataForPageOnModal?.vehicles__engine_status_by_command }}
              </div> -->
            </div>
            <div v-if="!dataForPageOnModal.vehicles__id">
              <!-- это пусто див -->
            </div>
            <div class="d-flex justify-content-between gap-10 pe-30">
              <button
                class="tw-app-btn-muted tw-app-btn-muted-lg tw-w-[108px] tw-justify-center"
                @click="$modal.hide('vehicleSettingModal')"
              >
                Отменить
              </button>
              <button
                class="tw-app-btn-primary tw-app-btn-primary-lg"
                @click="sendData"
              >
                Сохранить и закрыть
              </button>
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
    <BaseModal
      name="acceptDelete"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('acceptDelete')"
        ></button>

        <div class="text-center">
          <div class="tw-app-modal__title">
            {{ dataLang.confirm_dialog_delete }}
          </div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('acceptDelete')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["no"] }}
            </button>
            <button
              @click="
                () => {
                  activeModalForPin = 'delete';
                  deleteRow();
                }
              "
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang.confirm_btn__btn_yes }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
    <BaseModal
      name="acceptToArchive"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="295"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('acceptToArchive')"
        ></button>
        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            Точно переместить объект в архив?
          </div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('acceptToArchive')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["no"] }}
            </button>
            <button
              @click="
                () => {
                  activeModalForPin = 'archive';
                  toArchive();
                }
              "
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["yes"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
    <BaseModal
      name="acceptToggleWorkObject"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="295"
      classes="bg-transparent shadow-none"
    >
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn-close"
            @click="$modal.hide('acceptToggleWorkObject')"
          ></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p
            class="text-center fw-semi-bold mb-35"
            v-if="!typeActivateToggleObjectForModal"
          >
            Объект заблокирован
          </p>
          <p class="text-center fw-semi-bold mb-35" v-else>
            Объект разблокирован
          </p>

          <div class="d-flex justify-content-center mt-15 gap-10">
            <div
              class="base-button base-button--action fsc-14 px-20 text-uppercase"
              @click="$modal.hide('acceptToggleWorkObject')"
            >
              {{ dataLang["tracker_text55"] }}
            </div>
          </div>
        </div>
      </div>
    </BaseModal>

    <!-- <BaseModal name="acceptWithPin" width="420" :clickToClose="false" :shiftY="0.5" @before-close="pincodeModalHandler"
      :adaptive="true" height="auto" classes="bg-transparent shadow-none">
      <div class="modal-base-content modal-content py-20 px-30 rounded-25 bg-white" :style="{}">
        <div class="d-flex justify-content-end">
          <slot name="modal-header"></slot>
          <button type="button" class="btn-close" @click="$modal.hide('acceptWithPin')"></button>
        </div>
        <div
          class="modal-content-dynamic flex-grow-1 d-flex flex-column h-100 align-items-center justify-content-center container-with-input">
          <p class="fw-bold text-center">Внимание!</p>
          <p class=" mb-30 text-center">Введите пароль администратора!</p>

          <div class="d-flex flex-column align-items-center">
            <BaseInputNew placeholder="" :width="'225'" class="mb-10" :input-name="'pincode'"
              @input="(data) => (pincode = data.value)" value="" name-sign="">
            </BaseInputNew>
            <div class="d-flex justify-content-end gap-15">
              <div @click="$modal.hide('acceptWithPin')"
                class="btn btn-sm btn-opposite px-20 rounded-10 d-flex align-items-center justify-content-center">
                {{ dataLang['vehile_modal_btn_reset'] }}
              </div>
              <div @click="setActionWithPin"
                class="btn btn-sm btn-primary action-hover px-20 rounded-10 d-flex align-items-center justify-content-center">
                {{ dataLang['vehile_modal_btn_save'] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseModal> -->

    <BaseModal
      name="acceptWithPin"
      width="420"
      height="auto"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @before-close="pincodeModalHandler"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-pt-[38px] tw-px-[30px] tw-pb-[48px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('acceptWithPin')"
        ></button>
        <div class="tw-text-center">
          <div class="tw-text-[23px] tw-mb-[15px]">Внимание!</div>

          <div class="tw-my-[15px]">Введите пароль администратора!</div>

          <BaseInputNew
            inputClass="tw-app-input-type-3"
            @input="(data) => (pincode = data.value)"
          >
          </BaseInputNew>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('acceptWithPin')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отменить
            </button>
            <button
              @click="setActionWithPin"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<style lang="scss">

.line-hover {
  background-color: #eef4fa;
  transition: 0.3s ease;
  white-space: nowrap;
  color: black;
}
.line-hover:hover {
  background-color: #0a3982;
  color: white;
}

.transport-quick-filter-bar {
  background: #1d1e2c;
  padding: 14px 0 16px;
  border-top: 1px solid #fff;
}

.transport-quick-filter-bar__inner {
  gap: 12px 0;
  row-gap: 12px;
  column-gap: 0;
}

.transport-quick-filter-bar__group {
  flex: 0 0 auto;
  min-width: 88px;
  max-width: 100%;
  padding-right: 14px;
  padding-left: 14px;
}

.transport-quick-filter-bar__group--grow {
  flex: 1 1 140px;
  min-width: 120px;
}

.transport-quick-filter-bar__label {
  display: block;
  color: #fff;
  font-size: 12px;
  line-height: 1.2;
  margin-bottom: 6px;
}

.transport-quick-filter-bar__vrule {
  align-self: stretch;
  width: 1px;
  min-height: 48px;
  background: rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
}

.transport-quick-filter-bar__actions {
  padding-left: 18px;
  min-width: 120px;
}

.transport-quick-filter-bar__btn-find {
  border: none;
  border-radius: 6px;
  background: #f5e000;
  color: #1a1b23;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  cursor: pointer;
  line-height: 1;
  height: 24px;
  min-height: 24px;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.transport-quick-filter-bar__btn-find:hover {
  filter: brightness(1.05);
}

.transport-quick-filter-bar__btn-reset {
  border: none;
  background: transparent;
  color: #fff;
  font-size: 13px;
  text-decoration: underline;
  cursor: pointer;
  padding: 4px 0 0;
  text-align: center;
}

.transport-quick-filter-bar__btn-reset:hover {
  color: #e0e0e0;
}

.transport-quick-filter-bar .base-input--new {
  padding: 2px 2px;
  font-size: 14px;
  border: 1px solid rgba(245, 245, 245, 1);
  background: rgba(245, 245, 245, 0.15);
  color: white;
  border-radius: 3px;
  height: 24px;
  box-sizing: border-box;
}

.transport-quick-filter-bar .base-input--new:focus {
  background: rgba(245, 245, 245, 0.15);
  border-color: rgba(245, 245, 245, 1);
  color: white;
  box-shadow: none;
}

.transport-quick-filter-bar .multiselect__tags {
  height: 24px;
  min-height: 24px;
  padding-left: 2px;
  border: 1px solid rgba(245, 245, 245, 1);
  background: rgba(245, 245, 245, 0.15);
  color: white;
  border-radius: 3px;
  box-sizing: border-box;
}

.transport-quick-filter-bar .multiselect {
  height: 24px;
  min-height: 24px;
}

.transport-quick-filter-bar .multiselect__select {
  width: 24px;
  height: 24px;
}

.transport-quick-filter-bar .multiselect__input,
.transport-quick-filter-bar .multiselect__single {
  min-height: 18px;
  line-height: 18px;
  font-size: 9px;
  background: transparent;
  color: white;
  position: absolute;
  overflow-x: hidden;
  width: 95%;
}

.transport-quick-filter-bar .multiselect__select:before {
  top: 7px;
  right: 5px;
  color: white;
  background-size: 10px 10px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" class="bi bi-chevron-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path></svg>');
}

.transport-quick-filter-bar .multiselect__placeholder {
  color: rgba(255, 255, 255, 0.45);
}

.button-activate {
  height: 36px;
  border-top: 1px solid #ededed;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  padding-inline: 10px;
  box-shadow: 0px 7px 2px 0px #00000000;
  font-size: 14px;
  line-height: 19.6px;
  color: #1d1e2c;
  border-radius: 5px;
  cursor: pointer;
}

.button-activate--simple {
  background-color: #ddffe7;
}

.button-activate--block {
  background-color: #ffc8c8;
}

/* Health tooltip styles */
.health-tooltip {
  position: absolute;
  z-index: 5000;
  /* ensure above any modal overlays */
  max-width: 680px;
  color: #fff;
  background: #546887;
  border-radius: 12px;
  padding: 16px 18px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);

  /* arrow */
  &::after {
    content: "";
    position: absolute;
    left: var(--arrow-left, 50%);
    bottom: -12px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 12px solid #546887;
    /* point to item below */
  }
}

.health-tooltip__content {
  white-space: pre-wrap;
  font-size: 14px;
  line-height: 1.4;
}
</style>

<script>
import { VeTable } from "vue-easytable";
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import CitiesService from "@/api/CitiesService.js";
import SelectsService from "@/api/SelectsService";
import Modal from "@/components/Modals.vue";
import NewModal from "@/components/NewModal.vue";
import EventBus from "@/event-bus.js";
import BaseTextarea from "@/components/ui/BaseTextarea.vue";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import VehicleTab from "./transport-vehicles-tabs-modal/VehicleTab_rest.vue";
import ServicesTab from "./transport-vehicles-tabs-modal/ServicesTab.vue";
import IntervalEventsTab from "./transport-vehicles-tabs-modal/IntervalEventsTab.vue";
import SecurityTab from "./transport-vehicles-tabs-modal/SecurityTab.vue";
import TiresTab from "./transport-vehicles-tabs-modal/TiresTab.vue";
import FilesTab from "./transport-vehicles-tabs-modal/FilesTab.vue";
import RaytingTab from "./transport-vehicles-tabs-modal/RaytingTab.vue";
import NotesTab from "./transport-vehicles-tabs-modal/NotesTab.vue";
import CommentsTab from "./transport-vehicles-tabs-modal/CommentsTab.vue";
import SettingTab from "./transport-vehicles-tabs-modal/SettingTab.vue";
import BaseInputVue from "@/components/ui/BaseInput.vue";
import PlacesService from "@/api/PlacesService";
// import AddIcon from '../assets/icons/add.svg'
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import GeneralService from "@/api/GeneralService";
export default {
  components: {
    Modal,
    NewModal,
    VehicleTab,
    BaseTextarea,
    VueTabs,
    VTab,
    VeTable,
    ServicesTab,
    IntervalEventsTab,
    SecurityTab,
    TiresTab,
    NotesTab,
    CommentsTab,
    FilesTab,
    RaytingTab,
    SettingTab,
  },

  props: {},
  data() {
    return {
      newTab: null,
      oldTab: null,
      pincode: "",
      activeModalForPin: null,
      activeCurrentTab: "",
      errorStateInTab: false,
      loadingModal: false,
      loadAllSelect: false,

      listTabs: {
        vehicleTab: true,
        servicesTab: false,
        intervalEventsTab: false,
        securityTab: false,
        tiresTab: false,
        notesTab: false,
        commentsTab: false,
        filesTab: false,
        raytingTab: false,
        settingTab: false,
      },
      options: ["list", "of", "options"],
      rowStyleOption: {
        stripe: true,
      },
      cellSelectionOption: {
        enable: false,
      },
      sortOption: {
        sortChange: (params) => {
          this.sortChange(params);
        },
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          return "table-header-cell-class";
        },
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (
            column.field ===
            Object.keys(row.settings).find((x) => x == column.field)
          ) {
            return row.settings[column.field];
          }

          // vehicles__agregator_state
        },
      },
      checkboxOption: {
        // row select change event
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.activeSelectRowsMultiple = selectedRowKeys;
        },
        // selected all change event
        selectedAllChange: ({ row, isSelected, selectedRowKeys }) => {
          this.activeSelectRowsMultiple = selectedRowKeys;
        },
      },
      typeActivateToggleObjectForModal: true,

      selectsFilter: {
        city: [],
        place: [],
        markModel: [],
        status: [],
        color: [],
        dateOdometr: [],
        dateMoto: [],
        eventByMotohour: [],
        eventByKm: [],
        eventByDay: [],
        override: [],
        dvs: [],
        kpp: [],
        osago: [],
        kasko: [],
        to: [],
        tries: [],
        zam: [],
        comment: [],
        withoutdriver: [],
        withdriver: [],
        buyout: [],
        ygs: [],
        ygf: [],
        ygt: [],
        rayting: [],
      },

      updatedValues: {},
      dataForModal: {},
      dataForPageOnModal: {},
      editData: {},
      activeSelectRow: null,
      activeSelectRowsMultiple: [],
      activateTab: null,
      modeOpenModal: "create",
      modalOpened: false,
      cities: [],
      places: [],
      selectsData: {
        vehicles__color: [],
        filter_overdue: [],
        filter_yesno: [],
        filter_tires: [],
        filter_rayting: [],
      },
      filter: [],
      quickFilterRin: "",
      quickFilterMarkModel: "",
      quickFilterGosNumber: "",
      currentOpenedId: null,
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.currentOpenedId = row.vehicles__id;
              this.$modal.show("vehicleSettingModal", { mode: "edit" });
              this.modalOpened = true;
              // this.activateTab =
              //   this.dataLang['vehicles_page__modal__tab_object__name']
            },
          };
        },
      },
      limitPaginationValue: 50,
      healthTooltip: {
        visible: false,
        text: "",
        left: 0,
        top: 0,
        width: 640,
        arrowLeft: 0,
        currentIndex: null,
        hideTimer: null,
      },
      quickOrderProducts: [],
      quickOrderTranslationByProductId: {
        1: "products_text_8",
        2: "products_text_9",
        3: "products_text_7",
        4: "products_text_10",
        5: "products_text_29",
        6: "products_text_11",
        8: "products_text_22",
        9: "products_text_22",
        10: "products_text_22",
        11: "products_text_31",
        12: "products_text_23",
        13: "products_text_16",
        14: "products_text_17",
        15: "products_text_18",
        16: "products_text_19",
        17: "products_text_20",
        19: "products_text_24",
        22: "products_text_14",
        23: "products_text_15",
        24: "products_text_21",
        25: "products_text_12",
        26: "products_text_13",
      },
    };
  },
  methods: {
    loadQuickOrderProducts() {
      return GeneralService.get("/products", {
        params: {
          limit: 10000,
        },
      })
        .then((data) => {
          this.quickOrderProducts = data?.data?.data?.rows || [];
        })
        .catch(() => {
          this.quickOrderProducts = [];
          this.$toast.error("Ошибка загрузки кнопок заказа", {
            duration: 5000,
          });
        });
    },
    getQuickOrderButtonTitle(productId) {
      const translationKey = this.quickOrderTranslationByProductId[productId];
      const translatedName = translationKey
        ? this.dataLang?.[translationKey]
        : "";
      const productName =
        this.quickOrderProductsById[productId]
          ?.b2b_products_description__name || "";

      return translatedName || productName;
    },
    openQuickOrderModalById(productId) {
      const product = this.quickOrderProductsById[productId];
      if (!product) {
        return;
      }

      this.$modal.show("orderSendModal", {
        productId: product.b2b_products__id,
        productName: this.getQuickOrderButtonTitle(productId),
      });
    },
    onHealthBadgeEnter(e, item, index) {
      // ignore if tooltip text not allowed for this item
      if (!item || item.isShowCode === false) {
        return;
      }
      // cancel pending hide if any
      if (this.healthTooltip.hideTimer) {
        clearTimeout(this.healthTooltip.hideTimer);
        this.healthTooltip.hideTimer = null;
      }
      this.healthTooltip.text = this.dataLang[item["text-" + item.class]];
      this.healthTooltip.currentIndex = index;
      this.healthTooltip.visible = true;

      this.$nextTick(() => {
        const wrapper = this.$refs.vehicleModalWrapper;
        const badge = e.currentTarget;
        if (!wrapper || !badge) return;

        const wrapRect = wrapper.getBoundingClientRect();
        const badgeRect = badge.getBoundingClientRect();
        const pointerX = badgeRect.left + badgeRect.width / 2;
        const desiredWidth = this.healthTooltip.width;
        const estimatedHeight = 220;
        const pad = 12;

        let left = pointerX - wrapRect.left - desiredWidth / 2;
        left = Math.max(
          pad,
          Math.min(left, wrapRect.width - desiredWidth - pad)
        );

        let top = badgeRect.top - wrapRect.top - estimatedHeight - 16;
        if (top < pad) top = pad;

        this.healthTooltip.left = Math.round(left);
        this.healthTooltip.top = Math.round(top);

        this.$nextTick(() => {
          const tooltipEl = wrapper.querySelector(".health-tooltip");
          if (tooltipEl) {
            const rect = tooltipEl.getBoundingClientRect();
            let correctedTop = badgeRect.top - wrapRect.top - rect.height - 16;
            if (correctedTop < pad) correctedTop = pad;
            this.healthTooltip.top = Math.round(correctedTop);

            const arrowLeft =
              pointerX - (this.healthTooltip.left + wrapRect.left);
            const safeArrow = Math.max(
              14,
              Math.min(arrowLeft, rect.width - 14)
            );
            this.healthTooltip.arrowLeft = Math.round(safeArrow);
          }
        });
      });
    },
    onHealthBadgeLeave() {
      // small delay to allow moving cursor into tooltip without flicker
      if (this.healthTooltip.hideTimer)
        clearTimeout(this.healthTooltip.hideTimer);
      this.healthTooltip.hideTimer = setTimeout(() => {
        this.closeHealthTooltip();
      }, 120);
    },
    onTooltipEnter() {
      if (this.healthTooltip.hideTimer) {
        clearTimeout(this.healthTooltip.hideTimer);
        this.healthTooltip.hideTimer = null;
      }
    },
    onTooltipLeave() {
      this.closeHealthTooltip();
    },
    onHealthBadgeClick(e, item, index) {
      console.log(e, item, index);

      try {
        console.debug("onHealthBadgeClick fired", { item, index });
      } catch (err) {}
      // Show only if item has code enabled
      if (!item || item.isShowCode === false || !item.code) {
        this.closeHealthTooltip();
        return;
      }

      // toggle behavior for same item
      if (
        this.healthTooltip.visible &&
        this.healthTooltip.currentIndex === index
      ) {
        this.closeHealthTooltip();
        return;
      }

      this.healthTooltip.text = this.dataLang?.[item.code] || item.code;
      this.healthTooltip.currentIndex = index;
      this.healthTooltip.visible = true;

      this.$nextTick(() => {
        const wrapper = this.$refs.vehicleModalWrapper;
        const badge = e.currentTarget;
        if (!wrapper || !badge) return;

        const wrapRect = wrapper.getBoundingClientRect();
        const badgeRect = badge.getBoundingClientRect();

        const pointerX = badgeRect.left + badgeRect.width / 2; // center of clicked badge (in viewport)
        const desiredWidth = this.healthTooltip.width;

        // Default top: show above the health line with 16px gap
        const estimatedHeight = 220; // rough before measure; corrected below if element exists

        let left = pointerX - wrapRect.left - desiredWidth / 2;
        // clamp horizontally to keep inside modal area
        const pad = 12;
        left = Math.max(
          pad,
          Math.min(left, wrapRect.width - desiredWidth - pad)
        );

        // Provisional top
        let top = badgeRect.top - wrapRect.top - estimatedHeight - 16;
        if (top < pad) {
          // not enough space above, place above the buttons but still inside: put 16px from top
          top = pad;
        }

        // Apply and measure actual height to refine top if needed
        this.healthTooltip.left = Math.round(left);
        this.healthTooltip.top = Math.round(top);

        this.$nextTick(() => {
          const tooltipEl = wrapper.querySelector(".health-tooltip");
          if (tooltipEl) {
            const rect = tooltipEl.getBoundingClientRect();
            let correctedTop = badgeRect.top - wrapRect.top - rect.height - 16;
            if (correctedTop < pad) correctedTop = pad; // clamp inside
            this.healthTooltip.top = Math.round(correctedTop);

            // Arrow position relative to tooltip
            const arrowLeft =
              pointerX - (this.healthTooltip.left + wrapRect.left);
            // Keep arrow inside bubble but strive to point exactly at center
            const safeArrow = Math.max(
              14,
              Math.min(arrowLeft, rect.width - 14)
            );
            this.healthTooltip.arrowLeft = Math.round(safeArrow);
          }
        });

        // Outside click listener (defer to avoid catching the same click)
        setTimeout(() => {
          document.addEventListener("click", this.onOutsideTooltipClick, {
            once: true,
          });
        }, 0);
      });
    },
    onOutsideTooltipClick(ev) {
      const wrapper = this.$refs.vehicleModalWrapper;
      if (!wrapper) return this.closeHealthTooltip();
      const tooltipEl = wrapper.querySelector(".health-tooltip");
      if (tooltipEl && !tooltipEl.contains(ev.target)) {
        this.closeHealthTooltip();
      }
    },
    closeHealthTooltip() {
      this.healthTooltip.visible = false;
      this.healthTooltip.text = "";
      this.healthTooltip.currentIndex = null;
    },
    blockOrUnlockObject(type) {
      this.typeActivateToggleObjectForModal = type == "unblock";
      GeneralService.edit(
        `/objects/${this.currentOpenedId}/command/${type}?pincode=${this.pincode}`
      )
        .then((data) => {
          this.getDataForEngineStatus();
          this.$modal.show("acceptToggleWorkObject");
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message, { duration: 5000 });
        })
        .finally(() => {
          this.pincode = "";
        });
    },
    getDataForEngineStatus() {
      GeneralService.get(`/objects/${this.currentOpenedId}`)
        .then((data) => {
          this.dataForPageOnModal = data.data.data.rows[0];
        })
        .catch((error) => {
          this.$toast.error("Ошибка получение состояния двигателя", {
            duration: 5000,
          });
        });
    },
    checkClient() {
      GeneralService.get(`/caniuse/createObject?objectType=car`)
        .then((data) => {
          this.$modal.show("vehicleSettingModal", { mode: "create" });
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message, { duration: 5000 });
        });
    },
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.getTransportVehiclesAll({
        page: 1,
        limit: this.limitPaginationValue,
      });
    },
    forceReload() {
      this.listTabs[this.activeCurrentTab] = false;
      setTimeout(() => {
        this.listTabs[this.activeCurrentTab] = true;
      }, 1);
    },
    async beforeOpen(event) {
      if (event.params.mode == "edit") {
        await this.getDataForEngineStatus();
      }

      this.activeCurrentTab = "vehicleTab";
      if (
        event.name == "vehicleSettingModal" &&
        event.params.mode == "create"
      ) {
        this.modeOpenModal = "create";
      } else {
        // this.activateTab = this.dataLang['vehicles_page__modal__tab_object__name']
        this.modeOpenModal = "edit";
        // ensure health line and title are loaded for the currently opened vehicle
        if (this.currentOpenedId) {
          this.getHealth(this.currentOpenedId);
          this.getTitle(this.currentOpenedId);
        }
      }
      this.modalOpened = true;
    },
    beforeClose(event) {
      this.modalOpened = false;
      this.activateTab = null;
      this.closeHealthTooltip();

      this.activeCurrentTab = "";
      this.listTabs = {
        vehicleTab: true,
        servicesTab: false,
        intervalEventsTab: false,
        securityTab: false,
        tiresTab: false,
        notesTab: false,
        commentsTab: false,
        filesTab: false,
        raytingTab: false,
        settingTab: false,
      };
      this.dataForPageOnModal = {};
    },
    sendData() {
      this.$refs[this.activeCurrentTab].sendData(
        this.assignedTabChange,
        "",
        "",
        "",
        true
      );
    },
    handleTabChange(tabIndex, newTab, oldTab) {
      if (oldTab.title !== newTab.title) {
        this.loadingModal = true;
        this.listTabs[oldTab.$attrs["data-name"]] = true;
        this.activeCurrentTab = newTab.$attrs["data-name"];

        this.$refs[oldTab.$attrs["data-name"]].sendData(
          this.assignedTabChange,
          oldTab.title,
          oldTab,
          newTab
        );
      }
    },

    assignedTabChange(
      isForward,
      linkToTabHasName,
      oldTab,
      newTab,
      flagIsClose
    ) {
      if (this.modeOpenModal == "edit") {
        if (newTab && oldTab) {
          if (isForward) {
            this.listTabs[newTab.$attrs["data-name"]] = true;
            this.listTabs[oldTab.$attrs["data-name"]] = false;
          } else {
            this.activateTab = linkToTabHasName;
            this.listTabs[newTab.$attrs["data-name"]] = false;
            this.listTabs[oldTab.$attrs["data-name"]] = true;
          }
        } else {
          if (flagIsClose) {
            this.$modal.hide("vehicleSettingModal");
          }
        }
      } else {
        if (isForward) {
          this.$modal.hide("vehicleSettingModal");
        } else {
        }
      }

      this.loadingModal = false;
    },
    changeErrorInTab(state) {
      this.errorStateInTab = state;
    },
    loadingModalHandler(stateLoading) {
      this.loadingModal = stateLoading;
    },

    sortChange(params) {
      this.transportVehiclesData.sort((a, b) => {
        if (params.vehicles__id) {
          if (params.vehicles__id === "asc") {
            return a.vehicles__id - b.vehicles__id;
          } else if (params.vehicles__id === "desc") {
            return b.vehicles__id - a.vehicles__id;
          } else {
            return 0;
          }
        }
        if (params.cities__name) {
          if (params.cities__name === "asc") {
            return a.cities__name - b.cities__name;
          } else if (params.cities__name === "desc") {
            return b.cities__name - a.cities__name;
          } else {
            return 0;
          }
        }
        if (params.vehicle_places__address) {
          if (params.vehicle_places__address === "asc") {
            return a.vehicle_places__address - b.vehicle_places__address;
          } else if (params.vehicle_places__address === "desc") {
            return b.vehicle_places__address - a.vehicle_places__address;
          } else {
            return 0;
          }
        }
        if (params.vehicle_places__address) {
          if (params.vehicle_status__status === "asc") {
            return a.vehicle_status__status - b.vehicle_status__status;
          } else if (params.vehicle_status__status === "desc") {
            return b.vehicle_status__status - a.vehicle_status__status;
          } else {
            return 0;
          }
        }
        if (params.vehicles__name) {
          if (params.vehicles__name === "asc") {
            return a.vehicles__name - b.vehicles__name;
          } else if (params.vehicles__name === "desc") {
            return b.vehicles__name - a.vehicles__name;
          } else {
            return 0;
          }
        }
        if (params.vehicles__year_release) {
          if (params.vehicles__year_release === "asc") {
            return a.vehicles__year_release - b.vehicles__year_release;
          } else if (params.vehicles__year_release === "desc") {
            return b.vehicles__year_release - a.vehicles__year_release;
          } else {
            return 0;
          }
        }
        if (params.vehicles__gosnumber) {
          if (params.vehicles__gosnumber === "asc") {
            return a.vehicles__gosnumber - b.vehicles__gosnumber;
          } else if (params.vehicles__gosnumber === "desc") {
            return b.vehicles__gosnumber - a.vehicles__gosnumber;
          } else {
            return 0;
          }
        }
        if (params.vehicles__color) {
          if (params.vehicles__color === "asc") {
            return a.vehicles__color - b.vehicles__color;
          } else if (params.vehicles__color === "desc") {
            return b.vehicles__color - a.vehicles__color;
          } else {
            return 0;
          }
        }
        if (params.vehicles__odometr_next_date) {
          if (params.vehicles__odometr_next_date === "asc") {
            return (
              a.vehicles__odometr_next_date - b.vehicles__odometr_next_date
            );
          } else if (params.vehicles__odometr_next_date === "desc") {
            return (
              b.vehicles__odometr_next_date - a.vehicles__odometr_next_date
            );
          } else {
            return 0;
          }
        }
        if (params.vehicles__odometr) {
          if (params.vehicles__odometr === "asc") {
            return a.vehicles__odometr - b.vehicles__odometr;
          } else if (params.vehicles__odometr === "desc") {
            return b.vehicles__odometr - a.vehicles__odometr;
          } else {
            return 0;
          }
        }
        if (params.vehicle_cars__oil_dvs_next_mileage) {
          if (params.vehicle_cars__oil_dvs_next_mileage === "asc") {
            return (
              a.vehicle_cars__oil_dvs_next_mileage -
              b.vehicle_cars__oil_dvs_next_mileage
            );
          } else if (params.vehicle_cars__oil_dvs_next_mileage === "desc") {
            return (
              b.vehicle_cars__oil_dvs_next_mileage -
              a.vehicle_cars__oil_dvs_next_mileage
            );
          } else {
            return 0;
          }
        }
        if (params.vehicle_cars__oil_kpp_next_mileage) {
          if (params.vehicle_cars__oil_kpp_next_mileage === "asc") {
            return (
              a.vehicle_cars__oil_kpp_next_mileage -
              b.vehicle_cars__oil_kpp_next_mileage
            );
          } else if (params.vehicle_cars__oil_kpp_next_mileage === "desc") {
            return (
              b.vehicle_cars__oil_kpp_next_mileage -
              a.vehicle_cars__oil_kpp_next_mileage
            );
          } else {
            return 0;
          }
        }
        if (params.vehicle_cars__oil_kpp_next_mileage) {
          if (params.vehicle_cars__oil_kpp_next_mileage === "asc") {
            return (
              a.vehicle_cars__oil_kpp_next_mileage -
              b.vehicle_cars__oil_kpp_next_mileage
            );
          } else if (params.vehicle_cars__oil_kpp_next_mileage === "desc") {
            return (
              b.vehicle_cars__oil_kpp_next_mileage -
              a.vehicle_cars__oil_kpp_next_mileage
            );
          } else {
            return 0;
          }
        }
        if (params.vehicle_cars__oil_kpp_next_mileage) {
          if (params.vehicle_cars__oil_kpp_next_mileage === "asc") {
            return (
              a.vehicle_cars__oil_kpp_next_mileage -
              b.vehicle_cars__oil_kpp_next_mileage
            );
          } else if (params.vehicle_cars__oil_kpp_next_mileage === "desc") {
            return (
              b.vehicle_cars__oil_kpp_next_mileage -
              a.vehicle_cars__oil_kpp_next_mileage
            );
          } else {
            return 0;
          }
        }
        if (params.vehicle_osago__policy_to) {
          if (params.vehicle_osago__policy_to === "asc") {
            return a.vehicle_osago__policy_to - b.vehicle_osago__policy_to;
          } else if (params.vehicle_osago__policy_to === "desc") {
            return b.vehicle_osago__policy_to - a.vehicle_osago__policy_to;
          } else {
            return 0;
          }
        }
        if (params.vehicle_kasko__policy_to) {
          if (params.vehicle_kasko__policy_to === "asc") {
            return a.vehicle_kasko__policy_to - b.vehicle_kasko__policy_to;
          } else if (params.vehicle_kasko__policy_to === "desc") {
            return b.vehicle_kasko__policy_to - a.vehicle_kasko__policy_to;
          } else {
            return 0;
          }
        }
        if (params.vehicles__next_to_date) {
          if (params.vehicles__next_to_date === "asc") {
            return a.vehicles__next_to_date - b.vehicles__next_to_date;
          } else if (params.vehicles__next_to_date === "desc") {
            return b.vehicles__next_to_date - a.vehicles__next_to_date;
          } else {
            return 0;
          }
        }
        if (params.vehicle_tires__season) {
          if (params.vehicle_tires__season === "asc") {
            return a.vehicle_tires__season - b.vehicle_tires__season;
          } else if (params.vehicle_tires__season === "desc") {
            return b.vehicle_tires__season - a.vehicle_tires__season;
          } else {
            return 0;
          }
        }
        if (params.vehicles__notes_count) {
          if (params.vehicles__notes_count === "asc") {
            return a.vehicles__notes_count - b.vehicles__notes_count;
          } else if (params.vehicles__notes_count === "desc") {
            return b.vehicles__notes_count - a.vehicles__notes_count;
          } else {
            return 0;
          }
        }
        if (params.vehicles__comment_count) {
          if (params.vehicles__comment_count === "asc") {
            return a.vehicles__comment_count - b.vehicles__comment_count;
          } else if (params.vehicles__comment_count === "desc") {
            return b.vehicles__comment_count - a.vehicles__comment_count;
          } else {
            return 0;
          }
        }
        if (params.vehicles__ygsf_city_no_driver) {
          if (params.vehicles__ygsf_city_no_driver === "asc") {
            return (
              a.vehicles__ygsf_city_no_driver - b.vehicles__ygsf_city_no_driver
            );
          } else if (params.vehicles__ygsf_city_no_driver === "desc") {
            return (
              b.vehicles__ygsf_city_no_driver - a.vehicles__ygsf_city_no_driver
            );
          } else {
            return 0;
          }
        }
        if (params.vehicles__ygsf_city_with_driver) {
          if (params.vehicles__ygsf_city_with_driver === "asc") {
            return (
              a.vehicles__ygsf_city_with_driver -
              b.vehicles__ygsf_city_with_driver
            );
          } else if (params.vehicles__ygsf_city_with_driver === "desc") {
            return (
              b.vehicles__ygsf_city_with_driver -
              a.vehicles__ygsf_city_with_driver
            );
          } else {
            return 0;
          }
        }
        if (params.vehicles__ygsf_city_buyout) {
          if (params.vehicles__ygsf_city_buyout === "asc") {
            return a.vehicles__ygsf_city_buyout - b.vehicles__ygsf_city_buyout;
          } else if (params.vehicles__ygsf_city_buyout === "desc") {
            return b.vehicles__ygsf_city_buyout - a.vehicles__ygsf_city_buyout;
          } else {
            return 0;
          }
        }
        if (params.vehicles__ygs_world) {
          if (params.vehicles__ygs_world === "asc") {
            return a.vehicles__ygs_world - b.vehicles__ygs_world;
          } else if (params.vehicles__ygs_world === "desc") {
            return b.vehicles__ygs_world - a.vehicles__ygs_world;
          } else {
            return 0;
          }
        }
        if (params.vehicles__ygf_world) {
          if (params.vehicles__ygf_world === "asc") {
            return a.vehicles__ygf_world - b.vehicles__ygf_world;
          } else if (params.vehicles__ygf_world === "desc") {
            return b.vehicles__ygf_world - a.vehicles__ygf_world;
          } else {
            return 0;
          }
        }
        if (params.vehicles__ygt_world) {
          if (params.vehicles__ygt_world === "asc") {
            return a.vehicles__ygt_world - b.vehicles__ygt_world;
          } else if (params.vehicles__ygt_world === "desc") {
            return b.vehicles__ygt_world - a.vehicles__ygt_world;
          } else {
            return 0;
          }
        }
        if (params.vehicles__rayting) {
          if (params.vehicles__rayting === "asc") {
            return a.vehicles__rayting - b.vehicles__rayting;
          } else if (params.vehicles__rayting === "desc") {
            return b.vehicles__rayting - a.vehicles__rayting;
          } else {
            return 0;
          }
        }
        // else if (params.weight) {
        //   if (params.weight === 'asc') {
        //     return a.weight - b.weight
        //   } else if (params.weight === 'desc') {
        //     return b.weight - a.weight
        //   } else {
        //     return 0
        //   }
        // }
      });
    },

    resetFilter() {
      // this.selectsData
      this.filter = [];
      for (const key in this.selectsFilter) {
        this.selectsFilter[key] = [];
      }
      this.quickFilterRin = "";
      this.quickFilterMarkModel = "";
      this.quickFilterGosNumber = "";
      this.getTransportVehiclesAll({
        page: 1,
        limit: this.limitPaginationValue,
      });

      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      if (this.$refs.transportQuickFilterBar) {
        this.$refs.transportQuickFilterBar
          .querySelectorAll("input.base-input--new")
          .forEach((elem) => {
            elem.value = "";
          });
      }
    },
    setSelected(e, w) {},
    handleQuickRinInput(payload) {
      const nextValue = payload?.value ?? "";
      this.quickFilterRin = nextValue;
      this.fillFilter(payload);
    },
    handleQuickMarkModelInput(payload) {
      const nextValue = payload?.value ?? "";
      this.quickFilterMarkModel = nextValue;
      this.fillFilter(payload);
    },
    handleQuickGosNumberInput(payload) {
      const nextValue = payload?.value ?? "";
      this.quickFilterGosNumber = nextValue;
      this.fillFilter(payload);
    },
    fillFilter(data) {
      // Backend /objects/car/table сам делает LIKE '%value%'.
      // Поэтому для type='like' передаём "чистое" значение без ;percent;...;percent;.
      let newValueFilter = data.value;
      if (!data.value && data.value !== 0) {
        const indexCurrentFilter = this.filter.findIndex(
          (x) => x && x.field == data.name
        );
        if (indexCurrentFilter >= 0) {
          this.filter.splice(indexCurrentFilter, 1);
        }
        return;
      }
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },

    quickFilterCityLabel(opt) {
      if (!opt) {
        return "";
      }
      return opt.cities__name ?? "";
    },

    quickFilterPlaceLabel(opt) {
      if (!opt) {
        return "";
      }
      return opt.vehicle_places__name ?? "";
    },

    quickFilterMarkModelLabel(opt) {
      if (!opt) return "";
      return opt.label ?? opt.vehicles__name ?? "";
    },

    setFilterCity(e) {
      if (!e) {
        const idx = this.filter.findIndex((x) => x.field == "cities__id");
        if (idx >= 0) {
          this.filter.splice(idx, 1);
        }
        return;
      }
      if (!this.filter.find((x) => x.field == "cities__id")) {
        this.filter.push({
          field: "cities__id",
          value: e.cities__id,
        });
      } else {
        this.filter[
          this.filter.findIndex((x) => x.field == "cities__id")
        ].value = e.cities__id;
      }
    },

    setFilterPlace(e) {
      if (!e) {
        const idx = this.filter.findIndex(
          (x) => x.field == "vehicles__place_id"
        );
        if (idx >= 0) {
          this.filter.splice(idx, 1);
        }
        return;
      }
      if (!this.filter.find((x) => x.field == "vehicles__place_id")) {
        this.filter.push({
          field: "vehicles__place_id",
          value: e.vehicle_places__id,
        });
      } else {
        this.filter[
          this.filter.findIndex((x) => x.field == "vehicles__place_id")
        ].value = e.vehicle_places__id;
      }
    },

    setFilterMarkModel(e) {
      if (!e) {
        const idx = this.filter.findIndex(
          (x) => x && x.field == "vehicles__name"
        );
        if (idx >= 0) {
          this.filter.splice(idx, 1);
        }
        return;
      }

      const vehiclesName =
        e.vehicles__name ?? e.name ?? e.value ?? e.vehicles__model ?? "";

      this.fillFilter({
        name: "vehicles__name",
        value: vehiclesName,
        type: "input",
      });
    },

    extractTransportSelectArray(selects, predicate) {
      if (!selects) return [];

      if (Array.isArray(selects)) {
        const filtered = selects.filter((x) => predicate(x));
        return filtered.length ? filtered : [];
      }

      if (typeof selects === "object") {
        for (const key of Object.keys(selects)) {
          const value = selects[key];
          if (Array.isArray(value) && value.length) {
            const filtered = value.filter((x) => predicate(x));
            if (filtered.length) return filtered;
          }
        }
      }

      return [];
    },

    toArchive() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.hide("acceptToArchive");
        this.$modal.show("acceptWithPin");
      } else {
        this.$toast.error("Вы не выбрали ни одного поля", { duration: 5000 });
      }
    },

    setActionWithPin(type) {
      console.log(this.pincode);

      if (this.activeModalForPin == "archive") {
        this.toArchiveTransportVehiclesMultiple({
          listIds: this.activeSelectRowsMultiple,
          pincode: this.pincode,
        });
      } else if (this.activeModalForPin == "delete") {
        this.deleteRow();
      } else {
        this.blockOrUnlockObject(this.activeModalForPin);
      }
      this.activeModalForPin = null;
      this.$modal.hide("acceptWithPin");
      this.activeSelectRowsMultiple = [];
    },

    duplicateRows() {
      if (this.activeSelectRowsMultiple.length) {
        this.duplicateTransportVehiclesMultiple(this.activeSelectRowsMultiple);
        this.clickLoadData(1);
      } else {
        this.$toast.error("Вы не выбрали ни одного поля", { duration: 5000 });
      }
    },

    toArhive() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("acceptToArchive");
      } else {
        this.$toast.error("Вы не выбрали ни одного поля", { duration: 5000 });
      }
    },

    selectRangeTableRows(payload) {
      this.activeSelectRowsMultiple = payload.data.map((x) => x.vehicles__id);
    },
    clickLoadData(numPage) {
      const activeFilter = this.filter.filter(
        (item) =>
          item &&
          item.field &&
          item.value !== undefined &&
          item.value !== null &&
          item.value !== ""
      );

      this.getTransportVehiclesAll({
        limit: this.limitPaginationValue,
        page: numPage,
        type: "car",
        ...(activeFilter.length && { where: JSON.stringify(activeFilter) }),
      });
    },

    deleteActionAndModal() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("acceptDelete");
      } else {
        this.$toast.error("Вы не выбрали ни одного поля", { duration: 5000 });
      }
    },
    pincodeModalHandler() {},
    deleteRow(nameModal) {
      GeneralService.delete(`/objects/` + this.activeSelectRowsMultiple, {
        ...(this.pincode && { pincode: this.pincode }),
      })
        .then((data) => {
          this.$modal.hide("acceptWithPin");
          this.activeSelectRow = null;
          this.$modal.hide("acceptDelete");
          this.clickLoadData(1);
        })
        .catch((e) => {
          if (e.response.status == 409) {
            this.$modal.show("acceptWithPin");
            this.$toast.error(e.response.data.message, { duration: 5000 });
          } else if (e.response.status == 400) {
            this.pincode = "";
            this.$toast.error(e.response.data.message, { duration: 5000 });
            this.$modal.hide("acceptDelete");
            this.$modal.hide("acceptWithPin");
          }
        });
    },
    prepareKeysForModal(payloadData) {
      this.updatedValues = {};
      this.dataForModal = {};
      if (!payloadData) {
        for (const key in this.TollRoadsData[0]) {
          this.dataForModal[key] = null;
        }
      } else {
        this.dataForModal = Object.assign({}, payloadData);
      }
    },

    closeModal(data) {
      this.activeSelectRow = {};
      this.dataForModal = {};
      // this.$refs[data.nameForAction].$el.querySelectorAll('input').forEach(element => {
      //     element.value = ''
      // })
      this.modalOpened = false;
    },
    btnHandlerCloseModal() {
      EventBus.$emit("closeModal", { nameForAction: "vehicleSettingModal" });
    },
    customHeaderFilter(headerValue, rowValue, rowData, filterParams) {
      return rowData.name == filterParams.name && rowValue < headerValue; //must return a boolean, true if it passes the filter.
    },
    prepareLabelsForDefaultSelects(data) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
        });
      }
      return data;
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
    ...mapActions("transportVehiclesModule", [
      "getHealth",
      "getTitle",
      "getTransportVehiclesAll",
      "editTransportVehiclesMultiple",
      "createTransportVehiclesData",
      "deleteTransportVehiclesData",
      "downloadTransportVehiclesExel",
      "toArchiveTransportVehiclesMultiple",
      "duplicateTransportVehiclesMultiple",
      "toExcelTransportVehiclesData",
    ]),
  },
  mounted() {
    EventBus.$on("updateContentData", () => {
      this.clickLoadData(1);
      this.getHealth(this.currentOpenedId);
      this.getTitle(this.currentOpenedId);
    });
  },

  created() {
    this.getTransportVehiclesAll({ page: 1, limit: 50, type: "car" });
    this.loadQuickOrderProducts();
    this.loadAllSelect = false;
    Promise.all([
      CitiesService.getAll({
        params: {
          limit: 3000,
        },
      }).then((data) => {
        this.cities = data.data.data.rows;
      }),
      PlacesService.getAllWithoutID({
        params: {
          limit: 3000,
        },
      }).then((data) => {
        this.places = data.data.places.rows;
      }),
      SelectsService.getAll().then((data) => {
        this.selectsData = this.prepareLabelsForDefaultSelects(
          data.data.data.rows,
          "allSelects",
          true
        );
      }),
    ]).then(() => {
      this.loadAllSelect = true;
    });
  },
  computed: {
    ...mapState("transportVehiclesModule", [
      "transportVehiclesData",
      "transportVehiclesLoadStatus",
      "paginationStateParams",
      "lineHealthVehicle",
      "lineTitle",
      "transportVehiclesSelects",
    ]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("translationModule", ["dataLang"]),
    ...mapGetters("transportVehiclesModule", ["numPages"]),
    quickOrderProductsById() {
      return this.quickOrderProducts.reduce((acc, product) => {
        acc[Number(product.b2b_products__id)] = product;
        return acc;
      }, {});
    },
    evacuationProductId() {
      // In products list evacuation can come as light/truck/moto. Show a single button.
      return [8, 9, 10].find((id) => this.quickOrderProductsById[id]) || null;
    },
    quickFilterCitiesOptions() {
      const map =
        this.transportVehiclesSelects?.city ||
        this.transportVehiclesSelects?.cities;
      if (!map || typeof map !== "object") return [];
      return Object.entries(map).map(([id, name]) => ({
        cities__id: id,
        cities__name: name,
      }));
    },
    quickFilterPlacesOptions() {
      const map =
        this.transportVehiclesSelects?.place ||
        this.transportVehiclesSelects?.places;
      if (!map || typeof map !== "object") return [];
      return Object.entries(map).map(([id, name]) => ({
        vehicle_places__id: id,
        vehicle_places__name: name,
      }));
    },
    quickFilterMarkModelOptions() {
      const map =
        this.transportVehiclesSelects?.name ||
        this.transportVehiclesSelects?.markModel;
      if (!map || typeof map !== "object") return [];
      // backend: key -> label (key используется для фильтрации)
      return Object.entries(map).map(([key, label]) => ({
        vehicles__name: key,
        label,
      }));
    },

    columns() {
      return [
        {
          field: "",
          key: "aa",
          type: "checkbox",
          title: "",
          align: "center",
          width: 30,
        },
        {
          title: "Данные ТС",
          children: [
            {
              field: "vehicles__id",
              key: "1",
              title: "RIN",
              align: "center",
              width: 70,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <span>{column.title}</span>
                    <BaseInputNew
                      inputClass="tw-app-input-dark tw-app-input-dark-small"
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "input" }}
                      inputName={"vehicles__id"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
            {
              field: "cities__name",
              key: "2",
              title: "Город",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              align: "center",
              width: "10%",
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <span>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.city}
                      onInput={this.setFilterCity}
                      style={"width: 100%"}
                      label={"cities__name"}
                      placeholder={""}
                      id={"cities__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      customLabel={this.quickFilterCityLabel}
                      options={this.cities}
                    ></BaseSelect>
                  </div>
                );
              },
            },
            {
              field: "vehicle_places__name",
              key: "3",
              title: "Площадка",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              align: "center",
              width: "10%",
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <span>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.place}
                      onInput={this.setFilterPlace}
                      style={"width: 100%"}
                      label={"vehicle_places__name"}
                      placeholder={""}
                      id={"vehicle_places__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      customLabel={this.quickFilterPlaceLabel}
                      options={this.places}
                    ></BaseSelect>
                  </div>
                );
              },
            },

            {
              field: "vehicles__name",
              key: "5",
              title: "Марка/Модель",
              align: "center",
              width: "10%",
              sortBy: "",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <span>{column.title}</span>
                    <BaseInputNew
                      inputClass="tw-app-input-dark tw-app-input-dark-small"
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputName={"vehicles__name"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
            // {
            //   field: 'vehicles__year_release',
            //   key: '6',
            //   title: 'Год',
            //   align: 'center',
            //   width: 40,
            //   sortBy: '',
            //   renderHeaderCell: ({ column }, h) => {
            //     return (
            //       <div>
            //         <span>{column.title}</span>
            //         <BaseInputNew
            //           placeholder=''
            //           disabled={false}
            //           onInput={this.fillFilter}
            //           additionalParams={{ type: 'input' }}
            //           inputName={'vehicles__year_release'}
            //           value={''}
            //           nameSign={''}
            //           inputRef={'vehicles__year_release'}
            //           inputMask={'0000'}
            //         />
            //       </div>
            //     )
            //   }
            // },
            {
              field: "vehicles__gosnumber",
              key: "7",
              title: "Госномер",
              align: "center",
              width: 60,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <span>{column.title}</span>
                    <BaseInputNew
                      inputClass="tw-app-input-dark tw-app-input-dark-small"
                      placeholder=""
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputName={"vehicles__gosnumber"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
          ],
        },
        {
          title: "Актуальность пробега",
          children: [
            {
              field: "vehicles__odometr_next_date",
              key: "11",
              title: "Дата",
              align: "center",
              width: 60,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <span>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.dateOdometr}
                      onInput={(e, w) => {
                        if (
                          e.value !== "--" &&
                          e.value !== "filter_select_unselected"
                        ) {
                          let currentSelectType =
                            e.value == "filter_select_overdue"
                              ? "fail"
                              : "success";
                          if (
                            !this.filter.find(
                              (x) => x.field == "vehicles__odometr_next_date"
                            )
                          ) {
                            this.filter.push({
                              field: "vehicles__odometr_next_date",
                              value: currentSelectType,
                            });
                          } else {
                            this.filter[
                              this.filter.findIndex(
                                (x) => x.field == "vehicles__odometr_next_date"
                              )
                            ].value = currentSelectType;
                          }
                        } else {
                          let index = this.filter.findIndex(
                            (x) => x && x.field == "vehicles__odometr_next_date"
                          );
                          if (index >= 0) {
                            this.filter.splice(index, 1);
                          }
                        }
                      }}
                      style={"width: 100%"}
                      placeholder={""}
                      id={"vehicle_places__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      customLabel={({ label }) => {
                        return `${label}`;
                      }}
                      options={this.selectsData.filter_overdue}
                    ></BaseSelect>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {this.$time(row.vehicles__odometr_next_date)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(`${this.userSetting.company__tempalte_date}`)}
                  </span>
                );
              },
            },
            {
              field: "vehicles__odometr",
              key: "12",
              title: "Пробег",
              align: "center",
              width: 60,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <span>{column.title}</span>
                    <div style={"height: 19.5px"}></div>
                  </div>
                );
              },
            },
          ],
        },
        {
          title: "Актуальность моточасов",
          children: [
            {
              field: "vehicles__motohour_last_updated",
              key: "155242",
              title: "Дата",
              align: "center",
              width: 60,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <span>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.dateMoto}
                      onInput={(e, w) => {
                        if (
                          e.value !== "--" &&
                          e.value !== "filter_select_unselected"
                        ) {
                          let currentSelectType =
                            e.value == "filter_select_overdue"
                              ? "fail"
                              : "success";
                          if (
                            !this.filter.find(
                              (x) =>
                                x.field == "vehicles__motohour_last_updated"
                            )
                          ) {
                            this.filter.push({
                              field: "vehicles__motohour_last_updated",
                              value: currentSelectType,
                            });
                          } else {
                            this.filter[
                              this.filter.findIndex(
                                (x) =>
                                  x.field == "vehicles__motohour_last_updated"
                              )
                            ].value = currentSelectType;
                          }
                        } else {
                          let index = this.filter.findIndex(
                            (x) =>
                              x && x.field == "vehicles__motohour_last_updated"
                          );
                          if (index >= 0) {
                            this.filter.splice(index, 1);
                          }
                        }
                      }}
                      style={"width: 100%"}
                      placeholder={""}
                      id={"vehicle_places__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      customLabel={({ label }) => {
                        return `${label}`;
                      }}
                      options={this.selectsData.filter_overdue}
                    ></BaseSelect>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicles__motohour_last_updated
                      ? this.$time(row.vehicles__motohour_last_updated)
                          .utc(true)
                          .utcOffset(Number(this.userSetting.company__utc))
                          .format(`${this.userSetting.company__tempalte_date}`)
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "vehicles__motohour",
              key: "124111",
              title: "Моточасы",
              align: "center",
              width: 60,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <span>{column.title}</span>
                    <div style={"height: 19.5px"}></div>
                  </div>
                );
              },
            },
          ],
        },
        {
          title: "Ближайшие события",
          children: [
            {
              field: "vehicles__closest_event_by_day",
              key: "114242",
              title: "По дате",
              align: "center",
              width: 60,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <span>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.eventByDay}
                      onInput={(e, w) => {
                        if (
                          e.value !== "--" &&
                          e.value !== "filter_select_unselected"
                        ) {
                          let currentSelectType =
                            e.value == "filter_select_overdue"
                              ? "fail"
                              : "success";
                          if (
                            !this.filter.find(
                              (x) => x.field == "vehicles__closest_event_by_day"
                            )
                          ) {
                            this.filter.push({
                              field: "vehicles__closest_event_by_day",
                              value: currentSelectType,
                            });
                          } else {
                            this.filter[
                              this.filter.findIndex(
                                (x) =>
                                  x.field == "vehicles__closest_event_by_day"
                              )
                            ].value = currentSelectType;
                          }
                        } else {
                          let index = this.filter.findIndex(
                            (x) =>
                              x && x.field == "vehicles__closest_event_by_day"
                          );
                          if (index >= 0) {
                            this.filter.splice(index, 1);
                          }
                        }
                      }}
                      style={"width: 100%"}
                      placeholder={""}
                      id={"vehicle_places__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      customLabel={({ label }) => {
                        return `${label}`;
                      }}
                      options={this.selectsData.filter_overdue}
                    ></BaseSelect>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicles__closest_event_by_day
                      ? this.$time(row.vehicles__closest_event_by_day)
                          .utc(true)
                          .utcOffset(Number(this.userSetting.company__utc))
                          .format(`${this.userSetting.company__tempalte_date}`)
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "vehicles__closest_event_by_km",
              key: "1946342",
              title: "По пробегу",
              align: "center",
              width: 60,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <span>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.eventByKm}
                      onInput={(e, w) => {
                        if (
                          e.value !== "--" &&
                          e.value !== "filter_select_unselected"
                        ) {
                          let currentSelectType =
                            e.value == "filter_select_overdue"
                              ? "fail"
                              : "success";
                          if (
                            !this.filter.find(
                              (x) => x.field == "vehicles__closest_event_by_km"
                            )
                          ) {
                            this.filter.push({
                              field: "vehicles__closest_event_by_km",
                              value: currentSelectType,
                            });
                          } else {
                            this.filter[
                              this.filter.findIndex(
                                (x) =>
                                  x.field == "vehicles__closest_event_by_km"
                              )
                            ].value = currentSelectType;
                          }
                        } else {
                          let index = this.filter.findIndex(
                            (x) =>
                              x && x.field == "vehicles__closest_event_by_km"
                          );
                          if (index >= 0) {
                            this.filter.splice(index, 1);
                          }
                        }
                      }}
                      style={"width: 100%"}
                      placeholder={""}
                      id={"vehicle_places__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      customLabel={({ label }) => {
                        return `${label}`;
                      }}
                      options={this.selectsData.filter_overdue}
                    ></BaseSelect>
                  </div>
                );
              },
            },
            {
              field: "vehicles__closest_event_by_motohour",
              key: "1166363",
              title: "По моточасам",
              align: "center",
              width: 60,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <span>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.eventByMotohour}
                      onInput={(e, w) => {
                        if (
                          e.value !== "--" &&
                          e.value !== "filter_select_unselected"
                        ) {
                          let currentSelectType =
                            e.value == "filter_select_overdue"
                              ? "fail"
                              : "success";
                          if (
                            !this.filter.find(
                              (x) =>
                                x.field == "vehicles__closest_event_by_motohour"
                            )
                          ) {
                            this.filter.push({
                              field: "vehicles__closest_event_by_motohour",
                              value: currentSelectType,
                            });
                          } else {
                            this.filter[
                              this.filter.findIndex(
                                (x) =>
                                  x.field ==
                                  "vehicles__closest_event_by_motohour"
                              )
                            ].value = currentSelectType;
                          }
                        } else {
                          let index = this.filter.findIndex(
                            (x) =>
                              x &&
                              x.field == "vehicles__closest_event_by_motohour"
                          );
                          if (index >= 0) {
                            this.filter.splice(index, 1);
                          }
                        }
                      }}
                      style={"width: 100%"}
                      placeholder={""}
                      id={"vehicle_places__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      customLabel={({ label }) => {
                        return `${label}`;
                      }}
                      options={this.selectsData.filter_overdue}
                    ></BaseSelect>
                  </div>
                );
              },
            },
          ],
        },
        {
          title: "Срок действия полисов",
          children: [
            {
              field: "vehicle_osago__policy_to",
              key: "31",
              title: "ОСАГО",
              align: "center",
              width: 60,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <span>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.osago}
                      onInput={(e, w) => {
                        if (
                          e.value !== "--" &&
                          e.value !== "filter_select_unselected"
                        ) {
                          let currentSelectType =
                            e.value == "filter_select_overdue"
                              ? "fail"
                              : "success";
                          if (
                            !this.filter.find(
                              (x) => x.field == "vehicle_osago__policy_to"
                            )
                          ) {
                            this.filter.push({
                              field: "vehicle_osago__policy_to",
                              value: currentSelectType,
                            });
                          } else {
                            this.filter[
                              this.filter.findIndex(
                                (x) => x.field == "vehicle_osago__policy_to"
                              )
                            ].value = currentSelectType;
                          }
                        } else {
                          let index = this.filter.findIndex(
                            (x) => x && x.field == "vehicle_osago__policy_to"
                          );
                          if (index >= 0) {
                            this.filter.splice(index, 1);
                          }
                        }
                      }}
                      style={"width: 100%"}
                      placeholder={""}
                      id={"vehicle_places__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      customLabel={({ label }) => {
                        return `${label}`;
                      }}
                      options={this.selectsData.filter_overdue}
                    ></BaseSelect>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_osago__policy_to
                      ? this.$time(row.vehicle_osago__policy_to)
                          .utc(true)
                          .utcOffset(Number(this.userSetting.company__utc))
                          .format(`${this.userSetting.company__tempalte_date}`)
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "vehicle_kasko__policy_to",
              key: "32",
              title: "КАСКО",
              width: 60,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <span>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.kasko}
                      onInput={(e, w) => {
                        if (
                          e.value !== "--" &&
                          e.value !== "filter_select_unselected"
                        ) {
                          let currentSelectType =
                            e.value == "filter_select_overdue"
                              ? "fail"
                              : "success";
                          if (
                            !this.filter.find(
                              (x) => x.field == "vehicle_kasko__policy_to"
                            )
                          ) {
                            this.filter.push({
                              field: "vehicle_kasko__policy_to",
                              value: currentSelectType,
                            });
                          } else {
                            this.filter[
                              this.filter.findIndex(
                                (x) => x.field == "vehicle_kasko__policy_to"
                              )
                            ].value = currentSelectType;
                          }
                        } else {
                          let index = this.filter.findIndex(
                            (x) => x && x.field == "vehicle_kasko__policy_to"
                          );
                          if (index >= 0) {
                            this.filter.splice(index, 1);
                          }
                        }
                      }}
                      style={"width: 100%"}
                      placeholder={""}
                      id={"vehicle_places__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      customLabel={({ label }) => {
                        return `${label}`;
                      }}
                      options={this.selectsData.filter_overdue}
                    ></BaseSelect>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_kasko__policy_to
                      ? this.$time(row.vehicle_kasko__policy_to)
                          .utc(true)
                          .utcOffset(Number(this.userSetting.company__utc))
                          .format(`${this.userSetting.company__tempalte_date}`)
                      : ""}
                  </span>
                );
              },
            },
          ],
        },

        {
          title: "Контроль",
          children: [
            {
              field: "vehicle_tires__season",
              key: "41",
              title: "Ш",
              align: "center",
              width: 40,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <span>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.tries}
                      onInput={(e, w) => {
                        let indexCurrentFilter = this.filter.findIndex(
                          (x) => x.field == "vehicle_tires__season"
                        );

                        if (indexCurrentFilter >= 0) {
                          if (e.value == "filter_select_tires_summer") {
                            this.filter[indexCurrentFilter] = {
                              field: "vehicle_tires__season",
                              value: "vehicle_tires_season_summer",
                            };
                          } else if (e.value == "filter_select_tires_winter") {
                            this.filter[indexCurrentFilter] = {
                              field: "vehicle_tires__season",
                              value: "vehicle_tires_season_winter",
                            };
                          } else if (
                            e.value == "filter_select_tires_unselected"
                          ) {
                            this.filter.splice(indexCurrentFilter, 1);
                          }
                        } else {
                          let selectNow;

                          if (e.value == "filter_select_tires_summer") {
                            selectNow = {
                              field: "vehicle_tires__season",
                              value: "vehicle_tires_season_summer",
                            };
                          } else {
                            selectNow = {
                              field: "vehicle_tires__season",
                              value: "vehicle_tires_season_winter",
                            };
                          }
                          this.filter.push(selectNow);
                        }
                      }}
                      style={"width: 100%"}
                      placeholder={""}
                      id={"vehicle_places__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      customLabel={({ label }) => {
                        return `${label}`;
                      }}
                      options={this.selectsData.filter_tires}
                    ></BaseSelect>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.vehicle_tires__season
                      ? row.vehicle_tires__season[0]
                      : ""}
                  </span>
                );
              },
            },
            {
              field: "vehicles__notes_count",
              key: "51",
              title: "З",
              align: "center",
              width: 40,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <span>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.zam}
                      onInput={(e, w) => {
                        let indexCurrentFilter = this.filter.findIndex(
                          (x) => x.field == "vehicles__notes_count"
                        );

                        if (indexCurrentFilter >= 0) {
                          if (e.value == "filter_select_yes") {
                            this.filter[indexCurrentFilter] = {
                              field: "vehicles__notes_count",
                              value: "fail",
                            };
                          } else if (e.value == "filter_select_no") {
                            this.filter[indexCurrentFilter] = {
                              field: "vehicles__notes_count",
                              value: "success",
                            };
                          } else if (e.value == "filter_select_unselected") {
                            this.filter.splice(indexCurrentFilter, 1);
                          }
                        } else {
                          this.filter.push({
                            field: "vehicles__notes_count",
                            value:
                              e.value == "filter_select_no"
                                ? "success"
                                : "fail",
                          });
                        }
                      }}
                      style={"width: 100%"}
                      placeholder={""}
                      id={"vehicle_places__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      customLabel={({ label }) => {
                        return `${label}`;
                      }}
                      options={this.selectsData.filter_yesno}
                    ></BaseSelect>
                  </div>
                );
              },
            },
            {
              field: "vehicles__comment_count",
              key: "52",
              title: "КK",
              align: "center",
              width: 40,
              sortBy: "",
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class="multiselect-type-1 multiselect-type-1-small">
                    <span>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.comment}
                      onInput={(e, w) => {
                        let indexCurrentFilter = this.filter.findIndex(
                          (x) => x.field == "vehicles__comment_count"
                        );

                        if (indexCurrentFilter >= 0) {
                          if (e.value == "filter_select_yes") {
                            this.filter[indexCurrentFilter] = {
                              field: "vehicles__comment_count",
                              value: "fail",
                            };
                          } else if (e.value == "filter_select_no") {
                            this.filter[indexCurrentFilter] = {
                              field: "vehicles__comment_count",
                              value: "success",
                            };
                          } else if (e.value == "filter_select_unselected") {
                            this.filter.splice(indexCurrentFilter, 1);
                          }
                        } else {
                          this.filter.push({
                            field: "vehicles__comment_count",
                            value:
                              e.value == "filter_select_no"
                                ? "success"
                                : "fail",
                          });
                        }
                      }}
                      style={"width: 100%"}
                      placeholder={""}
                      id={"vehicle_places__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      customLabel={({ label }) => {
                        return `${label}`;
                      }}
                      options={this.selectsData.filter_yesno}
                    ></BaseSelect>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>{row.vehicles__comment_count == 0 ? "Нет" : "Да"}</span>
                );
              },
            },
          ],
        },

        {
          title: "R",
          key: "81",
          field: "vehicles__rayting",
          align: "center",
          width: 40,
          sortBy: "",
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <span>{column.title}</span>
                <BaseSelect
                  vModel={this.selectsFilter.rayting}
                  onInput={(e, w) => {
                    const clearFilterRating = () => {
                      this.filter = this.filter.filter(
                        (item) => !(item && item.field == "vehicles__rayting")
                      );
                    };

                    const ratingMap = {
                      filter_select_rayting_0: 0,
                      filter_select_rayting_1: 1,
                      filter_select_rayting_2: 2,
                      filter_select_rayting_3: 3,
                      filter_select_rayting_4: 4,
                      filter_select_rayting_5: 5,
                    };

                    if (
                      Object.prototype.hasOwnProperty.call(ratingMap, e.value)
                    ) {
                      clearFilterRating();
                      this.filter.push({
                        field: "vehicles__rayting",
                        value: ratingMap[e.value],
                      });
                    } else if (e.value == "filter_select_rayting_unselected") {
                      clearFilterRating();
                    }
                  }}
                  style={"width: 100%"}
                  placeholder={""}
                  id={"vehicle_places__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  customLabel={({ label }) => {
                    return `${label}`;
                  }}
                  options={this.selectsData.filter_rayting}
                ></BaseSelect>
              </div>
            );
          },
        },
        {
          field: "vehicle_status__status",
          key: "4",
          title: "Статус",
          align: "center",
          width: 30,
          sortBy: "",
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <span>{column.title}</span>
                <BaseSelect
                  vModel={this.selectsFilter.status}
                  onInput={(e, w) => {
                    if (
                      !this.filter.find((x) => x.field == "vehicles__status_id")
                    ) {
                      this.filter.push({
                        field: "vehicles__status_id",
                        value: e.status__value,
                      });
                    } else {
                      this.filter[
                        this.filter.findIndex(
                          (x) => x.field == "vehicles__status_id"
                        )
                      ].value = e.status__value;
                    }
                  }}
                  style={"width: 100%"}
                  placeholder={""}
                  id={"label"}
                  selectLabel={""}
                  deselectLabel={""}
                  customLabel={({ status }) => {
                    return `${status} `;
                  }}
                  options={[
                    {
                      status: "Карантин",
                      status__value: 2,
                      field: "vehicles__status_id",
                    },
                    {
                      status: "Готов",
                      status__value: 1,
                      field: "vehicles__status_id",
                    },
                  ]}
                ></BaseSelect>
              </div>
            );
          },
        },
        {
          field: "vehicles__agregator_state",
          key: "42221",
          title: this.dataLang["register_objects_car_text_4"],
          align: "center",
          width: 30,
          sortBy: "",
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <span>{column.title}</span>
                <BaseSelect
                  vModel={this.selectsFilter.agregatorState}
                  onInput={(e, w) => {
                    if (
                      !this.filter.find(
                        (x) => x.field == "vehicles__agregator_state"
                      )
                    ) {
                      this.filter.push({
                        field: "vehicles__agregator_state",
                        value: e.status__value,
                      });
                    } else {
                      this.filter[
                        this.filter.findIndex(
                          (x) => x.field == "vehicles__agregator_state"
                        )
                      ].value = e.status__value;
                    }
                  }}
                  style={"width: 100%"}
                  placeholder={""}
                  id={"label"}
                  selectLabel={""}
                  deselectLabel={""}
                  customLabel={({ status }) => {
                    return `${status} `;
                  }}
                  options={[
                    {
                      status: "Да",
                      status__value: "success",
                      field: "vehicles__agregator_state",
                    },
                    {
                      status: "Нет",
                      status__value: "fail",
                      field: "vehicles__agregator_state",
                    },
                  ]}
                ></BaseSelect>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.vehicles__agregator_state == "Не отображается"
                  ? "Нет"
                  : "Да"}
              </span>
            );
          },
        },
      ];
    },
  },
};
</script>
